<template>
    <div class="search-input">
        <font-awesome-icon icon="search" class="icon"/>
        <el-input v-model="inputValue" :placeholder="placeholder" @blur="active=true"
                  @focus="active=false" @keyup.enter.native="searchFn(inputValue)">

        </el-input>
    </div>
</template>

<script>

    export default {
        name: 'search-input',
        data() {
            return {
                inputValue: '',
                active: true
            }
        },
        watch: {
            value(val) {
                this.inputValue = val
            }
        },
        props: {
            value: {
                type: [String, Number],
                default: ''
            },
            placeholder:'',
            searchFn: {
                type: Function,
                default() {
                    return () => {

                    }
                }
            }
        }
    }
</script>

<style lang="scss" type="text/scss">
    .search-input {
        vertical-align: top;
        width: 200px;
        display: inline-block;
        background-color: #F5F5F5;
        position: relative;
        height: 34px;
        .icon {
            position: absolute;
            left:10px;
            top:50%;
            transform: translateY(-50%);
            cursor: pointer;
            font-size: 16px;
        }
        .el-input {
            vertical-align: top;
            input {
                height: 34px;
                cursor: pointer;
                margin-left:20px;
                background-color: transparent;
                border: none;
            }
            .el-input-group__append {
                border: none;
                color: $title-color;
            }
        }
    }
</style>